import { useIntl } from "react-intl";

export interface Condition {
   order: number;
   active: boolean;
   techName: string;
   operator: string;
   value: string[];
}

export interface FilterSection {
   active: boolean;
   conditions: Condition[];
   joinOperator: string;
   order: number;
}

export interface FilterItem {
   id: string;
   name: string;
   description: string;
   active: boolean;
   created: string;
   createdBy: string;
   filterSections: [];
   updated: string;
}

export const createFilterRows = (listResponse) => {
   const createFilterObjects = listResponse?.map((filter) => ({
      name: filter?.name,
      updated: filter?.updated ?? filter?.updatedAt,
      createdBy: filter?.createdBy,
      description: filter?.description,
      filterSections: filter?.filterSections,
      active: filter?.active,
      id: filter?.id,
      profileName: filter?.profileName,
   }));

   return createFilterObjects;
};

export const mapOperator = (operator: string, intl): string => {
   const operatorMap: Record<string, string> = {
      EQUAL: intl?.formatMessage({ id: "filter.equal" }),
      GREATER: intl?.formatMessage({ id: "filter.greater" }),
      LESS: intl?.formatMessage({ id: "filter.less" }),
      GREATER_OR_EQUAL: intl?.formatMessage({ id: "filter.greaterOrEqual" }),
      LESS_OR_EQUAL: intl?.formatMessage({ id: "filter.lessOrEqual" }),
      UNLIKE: intl?.formatMessage({ id: "filter.unlike" }),
      LIKE: intl?.formatMessage({ id: "filter.like" }),
      IN: intl?.formatMessage({ id: "filter.in" }),
      NOT_IN: intl?.formatMessage({ id: "filter.notIn" }),
      EMPTY: intl?.formatMessage({ id: "filter.empty" }),
      NOT_EMPTY: intl?.formatMessage({ id: "filter.notEmpty" }),
   };

   return operatorMap[operator] ?? "Równe";
};

export const createListForField = (responseColumnList) => {
   const listForSelect = responseColumnList.map(({ techName, label }) => ({
      value: techName,
      label: label,
   }));
   return listForSelect;
};

export const updateJoinOperatorInFirstConditions = (filters) => {
   if (!filters) return filters;
   return filters.map((filter) => {
      const sections = filter.filterSections ?? [];

      if (sections.length === 0) return filter;

      const updatedSections = sections.map((section, sectionIdx) => {
         const conditions = section.conditions ?? [];

         const updatedConditions = conditions.map((condition, conditionIdx) => {
            if (sectionIdx === 0 && conditionIdx === 0) {
               return {
                  ...condition,
                  joinOperator: "",
               };
            }

            if (condition.joinOperator === "") {
               return {
                  ...condition,
                  joinOperator: "OR",
               };
            }

            return condition;
         });

         return {
            ...section,
            conditions: updatedConditions,
         };
      });

      return {
         ...filter,
         filterSections: updatedSections,
      };
   });
};

export const getSerieSetting = (settingName, widgetSettings) => {
   const serieSettings = widgetSettings?.tableSeries?.[0];
   return serieSettings[settingName];
};

export const formatDateToDMY = (isoDate: string): string => {
   const date = new Date(isoDate);
   const day = String(date.getDate()).padStart(2, "0");
   const month = String(date.getMonth() + 1).padStart(2, "0");
   const year = date.getFullYear();

   return `${year}-${month}-${day}`;
};
